@if (!useGalaxyFormField) {
  <mat-form-field
    class="galaxy-form-field galaxy-phone-display-container"
    [ngClass]="{
      'no-hint-message': !formControl.invalid || formControl.pristine,
    }"
    appearance="outline"
    >
    <mat-label>{{ label | translate }}</mat-label>
    @if (disableAutoComplete) {
      <input style="display: none" type="text" name="disable-autocomplete" />
    }
    <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
    <input
      matInput
      class="galaxy-phone-input"
      [ngClass]="{ 'not-focused': !focused }"
      [id]="id"
      [name]="id"
      [formControl]="rawInputControl"
      placeholder="{{ placeholder ?? '' | translate }}"
      [required]="!!required"
      type="tel"
      (focus)="toggleFocus(true)"
      (blur)="blurInput()"
      [autocomplete]="disableAutoComplete ? 'chrome-off' : 'on'"
      />
    @if (!focused) {
      <div class="phone-number-formatted" aria-label="phone-number-formatted">
        <span>
          {{ nationalPhoneNumber$$ | async }}
        </span>
      </div>
    }
    @if (validatorError$ | async; as validatorError) {
      <mat-error>
        @if (validatorError !== '') {
          {{ validatorError | translate }}
        }
      </mat-error>
    }
  </mat-form-field>
} @else {
  <glxy-form-field
    class="galaxy-form-field galaxy-phone-display-container"
    [ngClass]="{
      'no-hint-message': !formControl.invalid || formControl.pristine,
    }"
    appearance="outline"
    >
    <glxy-label>{{ label | translate }}</glxy-label>
    @if (disableAutoComplete) {
      <input style="display: none" type="text" name="disable-autocomplete" />
    }
    <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
    <input
      matInput
      class="galaxy-phone-input"
      [ngClass]="{ 'not-focused': !focused }"
      [id]="id"
      [name]="id"
      [formControl]="rawInputControl"
      placeholder="{{ placeholder ?? '' | translate }}"
      [required]="!!required"
      type="tel"
      (focus)="toggleFocus(true)"
      (blur)="blurInput()"
      [autocomplete]="disableAutoComplete ? 'chrome-off' : 'on'"
      />
    @if (!focused) {
      <div class="glxy-phone-number-formatted" aria-label="phone-number-formatted">
        <span>
          {{ nationalPhoneNumber$$ | async }}
        </span>
      </div>
    }
    @if (validatorError$ | async; as validatorError) {
      <glxy-error>
        @if (validatorError !== '') {
          {{ validatorError | translate }}
        }
      </glxy-error>
    }
  </glxy-form-field>
}
